import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { TextInput } from 'react-native-paper';
import { Colors } from '../../../themes/colors';
import { DateRangeSelector, useFormContext } from '../../forms';
import { AlertInputs } from './types';

export const AlertOptions = () => {
  const { t } = useTranslation();
  const { setValue, control, getValues } = useFormContext();

  const alertName = getValues(AlertInputs.alertLabel);
  const alertNamePlaceholder = getValues(AlertInputs.alertLabelPlaceholder);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{t('alerts.customLabelTitle')}</Text>
      <TextInput
        value={alertName}
        onChangeText={(text) =>
          setValue(AlertInputs.alertLabel, text, { shouldDirty: false })
        }
        mode="outlined"
        style={styles.textInput}
        contentStyle={styles.textInputContainer}
        outlineColor={Colors.grayText}
        activeOutlineColor={Colors.grayText}
        outlineStyle={{ borderWidth: 1 }}
        placeholder={alertNamePlaceholder || t('common.optional')}
        placeholderTextColor={Colors.grayFill}
        multiline={true}
      />

      <Text style={styles.title}>{t('alerts.blackoutDates')}</Text>
      <DateRangeSelector
        control={control}
        setValue={setValue}
        maxYears={5}
        minDate={moment().format('YYYY-MM-DD')}
        styleContainer={styles.dateRangeContainer}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    minHeight: 245,
  },
  title: {
    color: Colors.blackText,
    fontSize: 16,
    fontWeight: '600',
    letterSpacing: -0.25,
    marginBottom: 12,
  },
  textInputContainer: {
    paddingHorizontal: 12,
    paddingTop: 10,
    paddingBottom: 10,
  },
  textInput: {
    height: 92,
    backgroundColor: Colors.white,
    marginBottom: 20,
  },
  dateRangeContainer: {
    ...Platform.select({
      web: {
        flexDirection: 'column',
        gap: 12,
      },
    }),
  },
});
